async function postJson(url, payload) {
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await response.json().catch(() => ({ error: 'El servidor devolvió una respuesta inválida.' }));
  if (!response.ok) {
    const error = new Error(data.error || `El servidor respondió ${response.status}.`);
    error.status = response.status;
    error.code = data.code;
    error.payload = data;
    throw error;
  }
  return data;
}

export const checkEmailExists = (identifier) => postJson('/api/auth/check', { identifier });

export const checkIdentifier = (identifier) => postJson('/api/auth/check', { identifier });

export const restorePlayerSession = (identifier, sessionToken) => postJson('/api/auth/restore', { identifier, sessionToken });

export const registerPlayer = (email, username) => postJson('/api/auth/register', { email, username });

export const requestLoginLink = (email) => postJson('/api/auth/request-login', { email });

export const resendVerificationCode = (email) => postJson('/api/auth/resend', { email });

export const verifyEmailCode = (email, code) => postJson('/api/auth/verify-code', { email, code });

export const verifyLoginToken = (token) => postJson('/api/auth/verify-token', { token });

export async function fetchSessionPlayer(sessionToken) {
  const response = await fetch('/api/auth/me', {
    headers: { Accept: 'application/json', Authorization: `Bearer ${sessionToken}` },
  });
  const data = await response.json().catch(() => ({ error: 'El servidor devolvió una respuesta inválida.' }));
  if (!response.ok) {
    const error = new Error(data.error || `El servidor respondió ${response.status}.`);
    error.status = response.status;
    throw error;
  }
  return data;
}

export function savePlayerSession({ sessionToken, expiresAt, player }) {
  if (sessionToken) localStorage.setItem('nacanaca-session', sessionToken);
  if (expiresAt) localStorage.setItem('nacanaca-session-expires', String(expiresAt));
  if (player) {
    localStorage.setItem('nacanaca-player-data', JSON.stringify(player));
    if (player.email) localStorage.setItem('nacanaca-email', player.email);
  }
}

export function loadPlayerSession() {
  try {
    return {
      sessionToken: localStorage.getItem('nacanaca-session') || '',
      player: JSON.parse(localStorage.getItem('nacanaca-player-data') || 'null'),
    };
  } catch {
    return { sessionToken: '', player: null };
  }
}

export function clearPlayerSession() {
  localStorage.removeItem('nacanaca-session');
  localStorage.removeItem('nacanaca-session-expires');
  localStorage.removeItem('nacanaca-player-data');
  localStorage.removeItem('nacanaca-player');
  localStorage.removeItem('nacanaca-email');
}
